import { FallbackProps } from "react-error-boundary";
import { Ban } from "lucide-react";

import TranslatedText from "./TranslatedText";

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  console.log(error);

  return (
    <div
      role="alert"
      className="flex h-screen w-full items-center justify-center dark:bg-black"
    >
      <div className="rounded-md bg-[#fdeded] px-6 py-10">
        <div className="flex items-start justify-start">
          <div className="text-[22px] text-[#d32f2f]">
            <Ban />
          </div>
          <div className="ms-3">
            <div className="text-[20px] font-bold text-[#5f2120]">
              <TranslatedText text={`layout.${"error-fallback-title"}`} />
            </div>
            <div className="mt-2 text-[18px]">
              <TranslatedText text={`layout.${"error-fallback-description"}`} />
            </div>
            <div
              className="mt-4 cursor-pointer text-[#5f2120] underline"
              onClick={() => {
                resetErrorBoundary();
              }}
            >
              <TranslatedText
                text={`layout.${"error-fallback-action-button"}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
